import React, {useEffect, useState} from "react";
import CVPDFEn from "../../assets/PDF/cv-sebastian_pitra-en.pdf";
import CVPDFEs from "../../assets/PDF/cv-sebastian_pitra-es.pdf";
import {Language} from "../../types";

const PDFResume: React.FC = () => {
  const [cvPdf, setCvPdf] = useState();

  useEffect(() => {
    const languageFromStorage: Language = JSON.parse(
      localStorage.getItem("language")!
    );

    if (languageFromStorage === "es") {
      setCvPdf(CVPDFEs);
    } else if (languageFromStorage === "en") {
      setCvPdf(CVPDFEn);
    }

    return;
  }, []);

  return (
    <div className=" overflow-hidden h-full w-full m-0 p-0 ">
      <embed
        src={cvPdf}
        type="application/pdf"
        className="h-[800px] w-full absolute top-0 left-0"
      />
    </div>
  );
};

export default PDFResume;
